import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;

  @media (${breakpoint.mdMin}) {
    min-height: 75px;
  }

  @media (${breakpoint.lgMin}) {
    &:hover, &:focus {
      > label {
        background-color: ${getColor('shadeAccentPrimary700')};
      }

      > span {
        color: ${getColor('textLink')};
        text-decoration: underline;
      }
    }

    &:active {
      > span {
        color: ${getColor('textSecondary')};
        text-decoration: unset;
      }
    }
  }  
`;

export const Label = styled.span<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
  padding: 0 8px;
  max-width: 75%;
`;
